module.exports = __webpack_public_path__ + "static/media/photo-title-slide-background.a4cf0d8f.jpg";